module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAmCAYAAACRWlj1AAAA0UlEQVRoge2ZQQrCQAxFX4t0r/fzDLpp76AutHs3Ra/X8QgjKVOQ2biwwiTNg0KXeQ0N+aSKMTbAGdgDO2wQgCfQiuAVOBoRyzmJ4GioczmhLque5RHBhzWpD+7zkLmkIbMtprTfeKXGTUNGs8hXVvEPmsYFteOC2nFB7axCUFa1GyCpIhp5xuTUyKomL4cCPvY/6EUwGFqyc6Y8WJVV06LUIjgYEsoZNkCXumgxD3aeB7XjgtpxQe24oHZcUDuW82A/50G/DyrG74PaMX4fhPYNytSk9XI0kvUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.png
// module id = 1060
// module chunks = 0